import { SET_FOCUS } from './focus-observer.constants';

export const setFocus = (payload: boolean) => ({
    type: SET_FOCUS,
    payload
});

export type Actions = ReturnType<typeof setFocus>;
